import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/modules/shadcn/ui/dialog";
import { useTranslation } from "react-i18next";

export interface VideoPlaybackDialogProps {
  videoUrl: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const VideoPlaybackDialog = ({
  videoUrl,
  open,
  onOpenChange,
}: VideoPlaybackDialogProps) => {
  const { t } = useTranslation("capture");
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-2xl">
        <DialogHeader>
          <DialogTitle>{t("playback.title")}</DialogTitle>
        </DialogHeader>
        <video src={videoUrl} controls autoPlay className="w-full rounded-md" />
      </DialogContent>
    </Dialog>
  );
};
